import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DirectiveModule } from '@fcom/common/directives';
import { ButtonModule, IconsModule, TrapFocusModule } from '@fcom/ui-components';
import { UiTranslateModule } from '@fcom/ui-translate';
import { ComponentsModule, FragmentService } from '@fcom/common';

import { PreChatComponent } from './components/pre-chat/pre-chat.component';
import { SalesforceChatService } from './services/salesforce-chat.service';
import { SalesforceChatConfigService } from './services/salesforce-chat-config.service';
import { ChatComponent } from './components/chat/chat.component';
import { ChatGlobalVisibilityComponent } from './components/chat-global-visibility/chat-global-visibility.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    DirectiveModule,
    UiTranslateModule,
    ButtonModule,
    IconsModule,
    TrapFocusModule,
  ],
  declarations: [ChatComponent, PreChatComponent, ChatGlobalVisibilityComponent],
  exports: [ChatComponent, ChatGlobalVisibilityComponent],
  providers: [SalesforceChatService, SalesforceChatConfigService, FragmentService],
})
export class ChatModule {}
